(() => {
  if (window.hlNavigationLoaded) return;
  window.hlNavigationLoaded = true;
  document.addEventListener('click', event => {
    document.querySelectorAll('.hl-navigation__catalogue[open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.hl-navigation__catalogue[open]').forEach(menu => {
      menu.open = false;
      menu.querySelector('summary').focus();
    });
  }, true);
})();
